import { Typography } from "@mui/material";
import toast from "react-hot-toast";
import { orderStatusInfo } from "./variables";

export const moneyMask = (value) => {
    value = value.replace('.', '').replace(',', '').replace(/\D/g, '')

    const options = { minimumFractionDigits: 2 }
    const result = new Intl.NumberFormat('pt-BR', options).format(
        parseFloat(value) / 100
    );

    return 'R$ ' + result
};

export const parseMoneyToCents = (value) => {
    if (value === undefined || value === null || value === '') {
        return 0;
    }

    if (typeof value === 'number') {
        return Number.isFinite(value) ? Math.round(value) : 0;
    }

    const text = String(value).trim();
    if (text.includes('R$') || text.includes(',')) {
        const normalized = text.replace(/R\$\s?/g, '').replace(/\./g, '').replace(',', '.');
        const asReais = parseFloat(normalized);
        return Number.isFinite(asReais) ? Math.round(asReais * 100) : 0;
    }

    const asNumber = Number(text);
    return Number.isFinite(asNumber) ? Math.round(asNumber) : 0;
};

export const moneyFormat = (value) => {
    const options = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    const result = new Intl.NumberFormat('pt-BR', options).format(
        parseMoneyToCents(value) / 100
    );

    return 'R$ ' + result;
};

export const copyToClipBoard = async (text, title = 'Texto') => {

    if (text) {

        await navigator.clipboard.writeText(text);

        toast.success(<Typography textAlign={'left'}>{(title)} copiado para sua área de transferência!</Typography>)
    };

};

export const clearNonNumericCharacters = (char) => {

    return char.replace(/\D/g, '');
};


export const hasImage = (img) => {

    return img
        ? img
        : "https://inovartgold.com.br/assets/logo/logo.jpg";
};

export const isWeekend = (date) => {
    const day = date.day();

    return day === 0 || day === 6;
};

export const nextBusinessDay = (from, addDays = 2) => {
    let cursor = from.startOf('day');
    let added = 0;
    while (added < addDays) {
        cursor = cursor.add(1, 'day');
        if (!isWeekend(cursor)) added += 1;
    }
    return cursor.hour(8).minute(30).second(0).millisecond(0);
};

export const isOutsideDeliveryHours = (value) => {
    if (!value || !value.isValid()) return true;
    const minutes = value.hour() * 60 + value.minute();
    return minutes < 8 * 60 + 30 || minutes > 17 * 60;
};

export const formatOptions = (data) => data?.data?.data?.map(item => ({ value: item.id, label: item.name })) ?? [];

export const formatOptionsWithPrice = (data) => data?.data?.data?.map(item => ({ value: item.id, label: item.name, price: item.price })) ?? [];


export const handleDownloadOrders = async (startDate, endDate, orders, headers) => {

    const fileName = startDate && endDate ? `relatorio_de_pedidos_${startDate}_${endDate}.csv` : `relatorio_de_pedidos.csv`

    const rows = orders.map(order => [
        order.id,
        order.name,
        order.created_by,
        order.selected_metal,
        order.ordered_at,
        orderStatusInfo[order.status]?.label || order.status,
        moneyFormat(order.price)
    ]);

    const csvContent = [headers, ...rows]
        .map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
        .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};